import axios, { type AxiosResponse } from 'axios';
import { type HotelReviewsResult } from "./types";

declare let window: any;

export default async function getHotelReviews(params: { limit: number, hotelId: number, page: number }): Promise<HotelReviewsResult['result']> {
    const defaultValues = {
        infoRatings: [],
        count: 0,
        rate: null,
        reviews: [],
        total: 0,
    }
    try {
        const { limit, hotelId, page } = params;
        const url = `${window.appConfig.apiGatewayUrl}/frontend/content/hotels/${hotelId}/tripadvisorReviews?limit=${limit}&page=${page}`;
        const response: AxiosResponse<HotelReviewsResult> = await axios({
            url,
            method: 'GET',
        });
        if (response.data.success) {
            return response.data.result;
        }
        return defaultValues;
    } catch {
        return defaultValues;
    }
}